// Burger menu: always wait for DOM so it works with deferred scripts
function runBurgerInit() {
    initBurgerMenu();
    // If elements weren't ready (e.g. deferred script ran early), try once after DOMContentLoaded
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function tryInit() {
            initBurgerMenu();
        }, { once: true, passive: true });
    }
}
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runBurgerInit, { passive: true });
} else {
    runBurgerInit();
}

/**
 * Initialize burger menu functionality (safe to call multiple times; skips if already inited)
 */
function initBurgerMenu() {
    const burgerButton = document.querySelector('.header__burger');
    const mobileMenu = document.querySelector('.header__mobile-menu');
    if (!burgerButton || !mobileMenu) {
        return;
    }
    if (burgerButton.getAttribute('data-burger-inited') === '1') {
        return;
    }
    burgerButton.setAttribute('data-burger-inited', '1');

    const mobileNavLinks = document.querySelectorAll('.mobile-nav-menu > li > a');

    // Toggle menu on burger click
    burgerButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation(); // Prevent document click-outside from seeing this click
        const isOpen = mobileMenu.classList.contains('is-open');

        if (isOpen) {
            mobileMenu.classList.remove('is-open');
            burgerButton.classList.remove('is-active');
            burgerButton.setAttribute('aria-expanded', 'false');
            document.body.style.overflow = '';
        } else {
            mobileMenu.classList.add('is-open');
            burgerButton.classList.add('is-active');
            burgerButton.setAttribute('aria-expanded', 'true');
            document.body.style.overflow = 'hidden';
        }
    });

    // Handle submenu toggles in mobile menu
    mobileNavLinks.forEach(function(link) {
        const parentLi = link.parentElement;
        const submenu = parentLi.querySelector('.sub-menu');

        if (submenu) {
            // Add click handler for parent items with submenus
            link.addEventListener('click', function(e) {
                e.preventDefault();

                // Toggle submenu
                if (submenu.classList.contains('show')) {
                    submenu.classList.remove('show');
                } else {
                    // Close other open submenus first
                    document.querySelectorAll('.mobile-nav-menu .sub-menu.show').forEach(function(openSubmenu) {
                        if (openSubmenu !== submenu) {
                            openSubmenu.classList.remove('show');
                        }
                    });
                    submenu.classList.add('show');
                }
            });
        }
    });

    // Close menu when clicking outside - use passive listener
    document.addEventListener('click', function(e) {
        if (!burgerButton.contains(e.target) && !mobileMenu.contains(e.target)) {
            if (mobileMenu.classList.contains('is-open')) {
                mobileMenu.classList.remove('is-open');
                burgerButton.classList.remove('is-active');
                burgerButton.setAttribute('aria-expanded', 'false');
                document.body.style.overflow = '';
            }
        }
    });

    // Close menu on window resize if desktop size - use passive listener
    window.addEventListener('resize', function() {
        if (window.innerWidth > 991) {
            if (mobileMenu.classList.contains('is-open')) {
                mobileMenu.classList.remove('is-open');
                burgerButton.classList.remove('is-active');
                burgerButton.setAttribute('aria-expanded', 'false');
                document.body.style.overflow = '';
            }
        }
    });

    // Close menu on Escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && mobileMenu.classList.contains('is-open')) {
            mobileMenu.classList.remove('is-open');
            burgerButton.classList.remove('is-active');
            burgerButton.setAttribute('aria-expanded', 'false');
            document.body.style.overflow = '';
            burgerButton.focus(); // Return focus to burger button
        }
    });
}
